import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { messages } from './messages';
import style from './style.module.less';

export const ImportStatusInProgress = () => {
  return (
    <div className={style['import-status-in-progress']}>
      <LoadingIndicator className={style['loading-indicator']} />
      <FormattedMessage {...messages.importInProgress} />
    </div>
  );
};
